import { css } from 'styled-components';

export const CommonPublicRoomContentCodeStyle = css`
  .card {
    margin-bottom: 1.5rem;
  }

  .card:last-child {
    margin-bottom: 0rem;
  }

  .card .card-header {
    font-size: 1.6rem;
  }

  .card .card-header:first-child {
    border-radius: 0rem !important;
  }

  .task-dropdown-title {
    margin-right: 0.25rem;
  }

  .task-dropdown-icon {
    margin-left: 0.25rem;
  }

  lottie-player {
    margin: 0 auto;
  }

  .tui-editor-contents p:first-child {
    margin-top: 0 !important;
  }

  img {
    max-width: 100%;
    height: auto !important;
  }

  .room-task-question-details p:last-child {
    margin-bottom: 0;
  }

  .room-task-questions {
    display: flex;
    margin-bottom: 1rem;
  }

  .glossary-term {
    cursor: pointer;
    text-decoration: underline !important;
    text-decoration-style: dotted !important;
    text-decoration-color: #949494 !important;
    text-underline-offset: 2px;
    color: inherit;
  }
  .terminal-top > .glossary-term {
    margin: 0 4px;
  }
`;
